import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Yonatan Gross`}</h1>
    <h5>{`I'm looking for a Full-Stack Developer/ Backend Developer position!`}</h5>
    <p>{`An enthusiastic Full-Stack Developer with broad technical exposure, bringing professionalism and dedication to web development projects.
Quickly grasps new technical skills and concepts to deliver under tight deadlines.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      